import { NgModule } from '@angular/core'
import { HasSettingDirective } from '@shared/directives/hasSetting.directive'
import { IsEllipsisActiveDirective } from '@shared/directives/isEllipsisActive.directive'
import { ScrollSiblingsDirective } from '@shared/directives/scrollSiblings.directive'
import { AnchorBottomDirective } from './anchorBottom.directive'
import { ButtonSpinnerDirective } from './button-spinner.directive'
import { FallBackImageDirective } from './fallbackImage.directive'
import { HasPrivilegeDirective } from './hasprivilege.directive'
import { ScopeInfiniteScrollDirective } from './scope-infinite-scroll.directive'
import { TTLClassDirective } from './tmpclass.directive'

@NgModule({
  declarations: [
    TTLClassDirective,
    HasPrivilegeDirective,
    FallBackImageDirective,
    HasSettingDirective,
    AnchorBottomDirective,
    ScrollSiblingsDirective,
    IsEllipsisActiveDirective,
    ButtonSpinnerDirective,
    ScopeInfiniteScrollDirective,
  ],
  exports: [
    TTLClassDirective,
    HasPrivilegeDirective,
    FallBackImageDirective,
    HasSettingDirective,
    AnchorBottomDirective,
    ScrollSiblingsDirective,
    IsEllipsisActiveDirective,
    ButtonSpinnerDirective,
    ScopeInfiniteScrollDirective,
  ],
})
export class DirectivesModule {}
